'use client';

import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';
import type { BusinessUnitDto } from '@/hooks/api/useAuth';

type Props = {
  open: boolean;
  businessUnits: BusinessUnitDto[];
  onSelect: (id: number) => void;
  isLoading?: boolean;
};

export const BusinessUnitPickerDialog: React.FC<Props> = ({
  open,
  businessUnits,
  onSelect,
  isLoading,
}) => {
  return (
    <Dialog open={open} disableEscapeKeyDown maxWidth="xs" fullWidth>
      <DialogTitle>Select business unit</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Your account has access to more than one business unit. Choose which one to use for this
          session.
        </Typography>
        <List disablePadding>
          {businessUnits.map((bu) => (
            <ListItemButton
              key={bu.id}
              onClick={() => onSelect(bu.id)}
              disabled={isLoading}
            >
              <ListItemText primary={bu.name} secondary={bu.code} />
            </ListItemButton>
          ))}
        </List>
        {isLoading && (
          <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
            Updating session…
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  );
};
